import { HashLocationStrategy, Location, LocationStrategy, CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { APP_BASE_HREF } from "@angular/common";
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";



// import { DataTableModule } from "angular2-datatable";
//import { NG2DataTableModule } from "angular2-datatable-pagination";
import { UiSwitchModule } from "angular2-ui-switch"
import { NguiAutoCompleteModule } from "@ngui/auto-complete";

import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { LoginModule } from "./login/login.module";
import { DashboardModule } from "./dashboard/dashboard.module";



import { ForgotPasswordComponent } from "./login/forgotPassword/forgotPassword.component";
import { StaffForgotPasswordComponent } from "./login/forgotPassword/staffforgotPassword.component";
import { LoginComponent } from "./login/login.component";

import { ExternalLoginComponent } from "./login/loginForm/extLoginForm.component";
import { ResetPasswordComponent } from "./login/resetPassword/resetPassword.component";
import { ExternalUserEmailVerificationComponent } from "./login/signup/ExternalUserEmailVerification.component";
import { SignupComponent } from "./login/signup/signup.component";


@NgModule({
        bootstrap: [AppComponent],
        declarations: [AppComponent],
        imports: [BrowserModule, NgxSpinnerModule,HttpClientModule ,CommonModule,  FormsModule, NguiAutoCompleteModule,
            BrowserAnimationsModule, UiSwitchModule,SharedModule, DashboardModule, LoginModule,  RouterModule.forRoot([
        { path: "login", component: LoginComponent },
        { path: "forgotPassword", component: ForgotPasswordComponent },
        { path: "changepassword", component: ResetPasswordComponent, data: { IsForceExpiredChangePassword: true } },
        { path: "staffforgotPassword", component: StaffForgotPasswordComponent },
        { path: "resetPassword", component: ResetPasswordComponent },
        { path: "signup", component: SignupComponent },
        { path: "extlogin", component: ExternalLoginComponent  },
        { path: "emailverfiy", component: ExternalUserEmailVerificationComponent },
        { path: "", redirectTo: "login", pathMatch: "full" }
    ])],
    providers: [{ provide: APP_BASE_HREF, useValue: "/jax/" }]



    })
export class AppModule { }


